var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReturnArrow = function SvgReturnArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.077,
    cy: 11.077,
    r: 11.077,
    transform: "translate(.923 .923)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.922 6.759c.368.368.394.949.078 1.347l-.078.089-2.918 2.916h9.291a1.015 1.015 0 0 1 .111 2.025l-.11.006H9.003l2.918 2.916c.368.369.394.95.078 1.348l-.078.088a1.016 1.016 0 0 1-1.348.08l-.088-.08-4.65-4.65a1.016 1.016 0 0 1-.079-1.347l.079-.088 4.65-4.65a1.015 1.015 0 0 1 1.436 0z"
  }))));
};
export default SvgReturnArrow;